/*
  Accessibility changes for public and admin pages
*/

/**
 * @deprecated prefer iconToolTips.mjs
 */
const iconToolTips = function ({
    parent = '',
    placement = 'auto',
}) {
    let areaEl = null;
    // are we checking the whole page or just the children of a parent element
    if (!parent) {
        areaEl = document.body;
    } else if (parent instanceof HTMLElement) {
        areaEl = parent;
    } else {
        areaEl = document.querySelector(parent);
    }

    areaEl?.querySelectorAll('.fa + .icon-label').forEach((el) => {
        const title = el.innerHTML;
        if (!title) {
            return;
        }
        // Is there a parent button/a element, if so we'll put the tooltip on that.
        let parentEl = el.closest('button, a');
        if (!parentEl) {
            // it no a/button we'll just use the .fa itself
            const sibling = el.previousElementSibling;
            if (sibling?.matches('.fa')) {
                parentEl = sibling;
            }
        }
        if (!parentEl) {
            return;
        }

        // eslint-disable-next-line no-undef
        const existing = bootstrap.Tooltip.getInstance(parentEl);
        if (existing) {
            // it already has a tooltip, so stop here
            return;
        }
        // initialize the tooltip
        // eslint-disable-next-line no-undef
        new bootstrap.Tooltip(
            parentEl,
            {
                title: title,
                html: true,
                placement,
            },
        );
    });
};

/**
 * Trigger tooltips on links/button with fa icons.
 * @deprecated prefer iconToolTips.mjs
 * @param {String|HTMLElement} parent Default to document.body
 */
var accessibleIcons = function (parent = '', opts = {}) {
    if (parent) {
        opts.parent = parent;
    }
    iconToolTips(opts);
};

/**
 * Remove currently showing icons from an element's children.
 * Useful when removing a whole element and its children
 * Since open tooltips are not contained within (they are added to the end of the DOM)
 * @deprecated prefer iconToolTips.mjs
 * @param {HTMLElement} parent
 */
// eslint-disable-next-line no-unused-vars
var removeIcons = function (parent) {
    try {
        parent?.querySelectorAll('[aria-describedby*="tooltip"]').forEach((el) => {
            // eslint-disable-next-line no-undef
            bootstrap?.Tooltip.getInstance(el)?.dispose();
        });
    } catch (err) {
        console.error(err);
    }
};

jQuery(() => {
    // trigger any icon tooltips on page
    accessibleIcons();

    // Temporarily add tabindex and focus on an element.
    // remove tabindex when focus leaves
    const temporaryFocusOnElement = function (el) {
        try {
            el.setAttribute('tabindex', -1);
            el.addEventListener('blur', () => {
                el.removeAttribute('tabindex');
            });
            el.addEventListener('focusout', () => {
                el.removeAttribute('tabindex');
            });
            el.focus();
        } catch {
            // ignore
        }
    };

    // skip links
    // If there is a '#' in the URL (someone linking directly to a page with an anchor), highlight that section and set focus to it.
    // The tabindex attribute is removed AFTER the user navigates away from the element to help address a nasty VoiceOver bug.
    if (document.location.hash) {
        try {
            const anchor = document.querySelector(document.location.hash);
            if (anchor) {
                temporaryFocusOnElement(anchor);
            }
        } catch {
            // ignore
        }
    }

    /* This function looks for a change in the hash (activation of an in-page link) and sets focus to and
        highlights the target element. This is necessary because webkit does not set focus as it should. If
        the hash is empty (the user hit the back button after activating an in-page link) focus is set to body.
    */
    window.addEventListener('hashchange', () => {
        let anchor = document.body;
        if (document.location.hash) {
            anchor = document.querySelector(document.location.hash) || document.body;
        }
        temporaryFocusOnElement(anchor);
    });
}); // end document ready
